var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUnlockIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.64372 9.50472H3.8284L3.82731 6.26975C3.82731 0.753253 10.5525 -2.12289 14.5187 1.84333C15.6546 2.97918 16.3587 4.54576 16.3587 6.26975V6.86086H14.6923C14.6923 5.06649 14.8105 4.49283 13.3405 3.02281C10.4211 0.103343 5.49362 2.23301 5.49362 6.26973V9.5047H17.5434C18.9982 9.5047 20.1861 10.6926 20.1861 12.1474L20.1872 22.3561C20.1872 23.0841 19.89 23.7448 19.4115 24.2232L19.4093 24.2211C18.9287 24.7006 18.2681 24.9989 17.5434 24.9989L2.64383 25C1.18793 25 0.00108461 23.8121 0.00108461 22.3573L0 12.1474C0 10.6926 1.18782 9.50472 2.64372 9.50472ZM17.5432 11.1711H2.64372C2.10887 11.1711 1.66734 11.6126 1.66734 12.1475L1.66626 22.3562C1.66626 22.8921 2.10779 23.3326 2.64264 23.3326H17.5433C17.8807 23.3326 18.2322 23.1026 18.2322 23.045C18.4101 22.8671 18.5197 22.623 18.5197 22.3561V12.1474C18.5208 11.6126 18.0792 11.1711 17.5432 11.1711Z",
    fill: "#56CA93"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUnlockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/UnlockIcon.68568dad.svg";
export { ForwardRef as ReactComponent };